import formatSizeNames from '../utils/formatSizeNames';

const calculateInternationalSizing = (type = 'all', toSize, fromSize):void => {

  // console.log('calc', fromSize, toSize, type)
  if(toSize && fromSize && toSize === fromSize) return;

  const collectionSizeWrapper = document.querySelector('[class*="size"].facet-section') as HTMLElement;
  const collectionSizeOptions = collectionSizeWrapper ? collectionSizeWrapper.querySelectorAll('.facet-block label') as NodeListOf<HTMLElement> : [];

  const sizeOptions = new Set([
    ...(type === 'all' ? document.querySelectorAll('[data-size-text-swap]') : []),
    ...collectionSizeOptions
  ]);

  sizeOptions.forEach(size => {

    const withPrefix = size.hasAttribute('data-size-with-prefix') ? true : false;

    const parent = size.closest('.size-selector') as HTMLElement;
    let optionRadio
    if(parent) {
      optionRadio = parent ?? parent.querySelector('[data-option-select]') as HTMLInputElement;
    } else {
      optionRadio = null
    }

    const labelText =  formatSizeNames(size.innerHTML, toSize, fromSize, withPrefix)

    const hasNumber = /\d/.test(labelText) ? true : false;

    if (hasNumber) {
      const newSize = labelText.toString();

      if(optionRadio) {
        optionRadio.dataset.optionValue = newSize;
      }

      if(newSize === 'NaN') {
        size.innerHTML = labelText;
      } else {
        size.innerHTML = newSize;
      }
      
    }
    size.classList.add('sizes-loaded')
  })
}

export default calculateInternationalSizing